export { default } from './ColorKitHero';
